import { Component, HostListener } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { Subject } from 'rxjs';
import { ConstantService } from './Shared/Services/constant-service';
import { UserService } from './Shared/Services/user.service';
import { PrimeNG } from 'primeng/config';
import { ToastModule } from 'primeng/toast';
import { EmitterService } from './Shared/Services/emitter.service';

@Component({
  selector: 'app-root',
  imports: [RouterModule, RouterOutlet,ToastModule],
  providers: [],
  templateUrl: './app.component.html'
})
export class AppComponent {
  userActivity: any;
  userInactive: Subject<any> = new Subject();

  constructor(
    private readonly userService: UserService,
    public constantService: ConstantService,
    private readonly primengConfig: PrimeNG,
    private readonly emitterService: EmitterService,
    private readonly router: Router) {
    //primeng config -  
    this.primengConfig.ripple.set(true);
    this.primengConfig.zIndex = {
      modal: 1000,    // dialog, sidebar
      overlay: 1000,  // dropdown, overlaypanel
      menu: 1000,     // overlay menus
      tooltip: 1100   // tooltip
    };
    this.primengConfig.setTranslation({
      accept: 'Accept',
      reject: 'Cancel',
      //translations
    });
    this.userService.init();
    this.setTimeout();
    this.userInactive.subscribe(() => {
      console.log('user has been inactive for ', this.constantService.sessionTimeout);
      this.constantService.isSessionExpired = true;
      alert("Session Timeout! Please login again.");
      this.router.navigate(['/login']);
    });
  }

  setTimeout() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), this.constantService.sessionTimeout);
    this.constantService.isSessionExpired = false;
  }

  @HostListener('window:mousemove') refreshUserState() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  mouseOut($event: any) {
    this.emitterService.onMouseOutMainWindow.emit("mainwindow")
  }

}
